const initialState = {
    StackDataRedux: []
}

export default initialState;